export default __webpack_public_path__ + "static/media/x-circle.33302c9e.svg";